import StickyAudioPlayer, { StickyAudioPlayerProps } from './StickyAudioPlayer';

export default StickyAudioPlayer;
export type { StickyAudioPlayerProps };
